import { SystemProps } from '@chakra-ui/react'
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise'

import { FilterCriteria } from '../../services/queryService'
import { TableColumnConfig } from './tablewidget.parts'

type DataType = any

export type ValuesOf<T extends object> = T[keyof T]

export const AG_GRID_FILTER_TYPES = {
  Numerical: 'agNumberColumnFilter',
  Text: 'agTextColumnFilter',
  Date: 'agDateColumnFilter',
  NoFilter: 'NoFilter',
  Custom: 'custom',
} as const

export type AgGridFilterCriteria = {
  // value filtering for
  filter: string
  filterType: FilterCriteria['filterValueType']
  type: FilterCriteria['condition']
  operator?: FilterCriteria['operator']
  condition1: any
  condition2: any
  dateFrom: any
  dateTo: any
  filterTo: any
}

export type AgGridFilterModel = Record<
  // Keyof columnDefs
  string,
  AgGridFilterCriteria
>

/**
 * This is the type of the data that is passed to the cell renderer.
 *
 * These props are separated out to redefine colDef as always being available.
 */
export type CellRendererProps<Value = any> = ICellRendererParams<any, Value> & {
  colDef: ColDef
}

/**
 * Extend AG Grid types.
 */
declare module 'ag-grid-enterprise' {
  export interface ColDef extends Omit<DataType, 'value'> {
    /** Text content to use for the cell. Use this if overriding field content. */
    text?: string
    align?: SystemProps['textAlign']
    filterType?: ValuesOf<typeof AG_GRID_FILTER_TYPES>
    header?: string
    tableColumnConfig?: TableColumnConfig
  }
}
declare module 'ag-grid-community' {
  export interface ColDef extends Omit<DataType, 'value'> {
    /** Text content to use for the cell. Use this if overriding field content. */
    text?: string
    align?: SystemProps['textAlign']
    filterType?: ValuesOf<typeof AG_GRID_FILTER_TYPES>
    tableColumnConfig?: TableColumnConfig
  }
}
